import PptxGenJS from 'pptxgenjs'
import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

const diseaseRadarLayout = {
  width: 5,
  height: 3
}
type diseaseRadarProps = KojinPptxComponentsProps & {
  top: number
}
type diseaseRadarReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const diseaseRadar = ({
  top,
  ...other
}: diseaseRadarProps): diseaseRadarReturnValue => {
  const { pptx, layout, slide, search, kojin } = other
  if (!kojin) return { slide, bottom: top }
  if (!search.disease || search.disease.length === 0) return { slide, bottom: top }
  if (!kojin.diseases || kojin.diseases.length === 0) return { slide, bottom: top }

  const maxDiseaseScore = kojin.diseases.reduce((max, { score }) => Math.max(max, score ?? 0), 0)
  if (maxDiseaseScore <= 0) return { slide, bottom: top }

  const baseRate = 20
  let hasScore = false
  const scores = search.disease.flatMap((disease) => {
    if (!disease.icd10code) return []
    let score = 0
    kojin.diseases?.filter((d) => disease.icd10code?.startsWith(d.icd10code)).forEach((d) => {
      score += d.score
    })
    if (score) hasScore = true
    return {
      label : disease.diseaseName,
      score: baseRate + ((score * 100) / maxDiseaseScore)
    }
  })
  if (!hasScore) return { slide, bottom: top }

  // pptxのradarは左右が逆なので、反転させる
  const invertScores = scores.map((r, i, arr) => (i === 0) ? r : arr[arr.length - i])

  slide.addChart(pptx.ChartType.radar, [{
    name: 'diseases of interest',
    labels: invertScores.map((disease) => disease.label),
    values: invertScores.map((disease) => disease.score)
  }], {
    x: slideFrom(layout, 'left', 0), y: top + layout.margin, 
    w: diseaseRadarLayout.width, 
    h: diseaseRadarLayout.height,
    radarStyle: "filled",
    showTitle: false,
    chartColors: ['f39811'],
    chartColorsOpacity: 80,
    lineDataSymbol: 'dot',
    valAxisHidden: true,
    valAxisMaxVal: 100 + baseRate,
    valAxisMinVal: 0,
    catAxisLabelFontFace: layout.baseFont.fontFace,
    catAxisLabelFontSize: layout.baseFont.fontSize * 0.8,
    catAxisTitleFontFace: layout.baseFont.fontFace,
    catAxisTitleFontSize: layout.baseFont.fontSize * 0.8
  })
  return {
    slide,
    bottom: top + layout.margin + diseaseRadarLayout.height
  }
}
